import type { Card, Schema } from './api.js'

/**
 * Доска: колонки по этапам. Перетаскивания нет — переходы делаются кнопками в
 * панели карточки, так в ТЗ. Колонка «Выполнено» показывает последние сверху,
 * остальные тоже по свежести правки.
 */

export function Board({
  cards,
  schema,
  selected,
  onSelect,
}: {
  cards: Card[]
  schema: Schema
  selected: string | null
  onSelect: (path: string) => void
}) {
  return (
    <div className="board">
      {schema.stages.map((stage) => {
        const column = cards.filter((c) => c.stage === stage.ключ)
        return (
          <section className="column" key={stage.ключ}>
            <header>
              <h3>{stage.название}</h3>
              <span className="count">{column.length}</span>
            </header>
            {column.length === 0 && <p className="empty">пусто</p>}
            {column.map((card) => (
              <CardTile
                key={card.path}
                card={card}
                schema={schema}
                selected={card.path === selected}
                onSelect={onSelect}
              />
            ))}
          </section>
        )
      })}
    </div>
  )
}

export function CardTile({
  card,
  schema,
  selected,
  onSelect,
}: {
  card: Card
  schema: Schema
  selected: boolean
  onSelect: (path: string) => void
}) {
  const rubric = schema.rubrics.find((r) => r.ключ === card.rubric)
  const direction = schema.directions.find((d) => d.ключ === card.direction)
  const format = schema.formats.find((f) => f.ключ === card.format)

  return (
    <article
      className={`card${selected ? ' selected' : ''}${card.isNew ? ' fresh' : ''}`}
      onClick={() => onSelect(card.path)}
    >
      <div className="title">{card.title}</div>
      <div className="meta">
        {card.status && <StatusChip status={card.status} />}
        {format && <span className="chip">{format.название}</span>}
        {rubric && <span className="chip">{rubric.название}</span>}
        {direction && <span className="chip">{direction.название}</span>}
        {card.expert && <span className="chip">{card.expert}</span>}
        {card.lastEditor === 'claude' && <span className="chip claude">Claude</span>}
        {card.isNew && <span className="chip accent">новое</span>}
      </div>
    </article>
  )
}

function StatusChip({ status }: { status: string }) {
  const tone =
    status === 'на-переделку' ? 'warn' : status === 'принято' || status === 'опубликован' ? 'ok' : ''
  const label: Record<string, string> = {
    'на-переделку': 'на переделку',
    'на-проверке': 'на проверке',
  }
  return <span className={`chip ${tone}`}>{label[status] ?? status}</span>
}
